export const SERVER_CONTENT_ELEMENT_ID = 'missions-server-content';

/**
 * Guild and mission pages arrive with a server-rendered content block (heading, description,
 * internal links) so crawlers that never reach the dashboard's API still get the page.
 * Once the app has loaded the same data — or navigates elsewhere — the block comes out.
 */
export const removeServerRenderedContent = (): void => {
    document.getElementById(SERVER_CONTENT_ELEMENT_ID)?.remove();
};
